export default "__VITE_ASSET__516620de__"